<div class="col card" filesDnd (fileDropped)="onFileDropped($event,fileType)">
    <div class="row">
      <div class="col">
        <div class="text-right">
            <label style="color: #2A96FF; font-weight: 500;margin-right: 10px;">Upload fichiers</label>
            <button class="btn-style" (click)="onSelectFiles(files)">
              <label>
              <fa-icon class="fa fa-lg add-document"
                      [icon]="fa['faPaperPlane']"></fa-icon>
              </label>
          </button>
        </div>
        <div *ngIf="files?.length<1">
          <fa-icon class="fa fa-2x" style="color: rgba(42, 150, 255,0.4);"
                   [icon]="fa['faCloud']"></fa-icon>
          <h3 style="color: rgba(36, 113, 190, 0.4);">Glissez ici les fichiers</h3>
        </div>
        <div *ngIf="files?.length>0">
          <div class="row" style="margin-bottom: 50px">
            <div class="fileElement col-5" *ngFor="let file of files; let index=index">
                <div class="delete-btn">
                  <fa-icon [icon]="fa['faTrash']" (click)="deleteFile(index)"></fa-icon>
                </div>
                <div style="width: 80%;display: inline-block;">
                  <p class="file-name expandable">{{expandFileName(file.name)}}</p>
                  <div class="progress-cont">
                    <div class="progress" [style.width]="file.progress + '%'">
                    </div>
                  </div>
                </div>
                <div style="display: inline-block;font-size: 25px">
                  <fa-icon [icon]="fa['faClipboard']"></fa-icon>
                </div>
            </div>
          </div>
        </div>
        <input type="file" style="display: none" #fileDropRef2 id="audioDropRef2" multiple
               (change)="fileBrowseHandler($event.target?.files, fileType)"/>
        <label for="audioDropRef2" class="select-label">
          <fa-icon class="fa fa-2x"
                   [icon]="fa['faUpload']"></fa-icon>
          <br>
          Sélectionner un fichier...
        </label>
      </div>
    </div>
  </div>